// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu--2BnBM","Tag":"Tag--2m0uI"};